"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetadataObject = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type guard checking whether input is an instance of {@link IMetadataObject}.
 *
 * @public
 */
function isMetadataObject(obj) {
    var c = obj;
    return !isEmpty_1.default(c) && c.type !== undefined && c.ref !== undefined;
}
exports.isMetadataObject = isMetadataObject;
//# sourceMappingURL=types.js.map